export default __webpack_public_path__ + "static/media/tromboprofilaxis.6d156b0f.pdf";